export default {
  'chat access': 'Access Chat',
  'chat administer': 'Administer Chat',
}
